import EventableObject from './eventable_object';
import Viewport from './viewport';
import Settings from './settings';
import DataBlock from './data_block';

import Page from './page';
import FontDefinition from './font_definition';

import ImageLayer from './layers/image_layer';
import CleanLayer from './layers/clean_layer';
import TextLayer from './layers/text_layer';

import KaitaiStream from 'kaitai-struct/KaitaiStream';
//import Lator from './lator.ksy';
import Lator from './lator_kaitai';

var base64js = require('base64-js');
var Buffer = require('buffer').Buffer;
var LZ4 = require('lz4');
var localforage = require('localforage');

/*
import ValuesLayer from './layers/values_layer';
import ZoneLayer from './layers/zone_layer';
import ZoneOverlayLayer from './layers/zone_overlay_layer';
*/

export default class Project extends EventableObject {
  constructor(app, filename) {
    super();

    this.app = app;
    this.name = 'lator';
    this.ready = true;

    this.canvas = document.createElement('canvas');
    this.canvas.width = 0;
    this.canvas.height = 0;

    this.viewport = new Viewport(this.canvas);
    this.viewport.addEventListener('click', pos => {
      this.onClick(pos.x, pos.y);
    });
    this.viewport.addEventListener('select', selection => {
      if (!this.activePage)
        return;

      if (selection) {
        this.activePage.updateSelection(selection);
      } else {
        this.activePage.selectLayer(null);
      }
    });
    this.viewport.addEventListener('mousemove', pos => {
      this.onMouseMove(pos.x, pos.y);
    });
    this.viewport.addEventListener('mousemove-out', pos => {
      this.onMouseMove(null, null);
    });
    this.viewport.addEventListener('mousewheel', e => {
      this.update();
    });

    window.addEventListener('keydown', e => {
      if (['input', 'select', 'textarea'].includes(e.target.tagName.toLowerCase()))
        return;

      let dx = 0, dy = 0;
      if (e.keyCode == 38)
        dy = -1;
      else if (e.keyCode == 40)
        dy = +1;
      else if (e.keyCode == 37)
        dx = -1;
      else if (e.keyCode == 39)
        dx = +1;

      if (e.shiftKey) {
        dx *= 10;
        dy *= 10;
      }

      let textLayer = (this.activePage && this.activePage.selectedLayer && this.activePage.selectedLayer.type == 'text') ? this.activePage.selectedLayer : null;
      if (textLayer && (dx != 0 || dy != 0)) {
        textLayer.move(dx, dy);
      }
    });

    this.pages = [];
    this.activePage = null;
    this.newPageId = 1;

    this.fontDefinitions = JSON.parse(Settings.get('font-definitions', '[]')).map(x => {
      let fd = new FontDefinition();
      fd.import(x);
      return fd;
    });

    this.currentFontDefinition = new FontDefinition();
    this.currentFontDefinition.import(JSON.parse(Settings.get('current-font-definition', JSON.stringify(this.currentFontDefinition.export()))));

    //this.ui = new UI(this);

    if (filename) {
      this.loadPage(filename);
    }

    this.update();

    if (Settings.get('autosave', 1) != 0) {
      localforage.getItem('__autosave', (err, value) => {
        if (err || !value)
          return;

        this.importBinary(value);
      });
    }

    window.onbeforeunload = (e) => {
      if (Settings.get('autosave', 1) != 0) {
        this.makeAutosave();
      }
    };

    setTimeout(() => {
      this.__autosave();
    }, 1000);
  }

  makeAutosave() {
    let data = this.exportBinary().getData();
    localforage.setItem('__autosave', data);
  }

  __autosave() {
    if (!this.ready || (this.activePage && !this.activePage.ready)) {
      setTimeout(() => {
        this.__autosave();
      }, 1000);
      return;
    }

    this.ready = false;
    this.update();

    setImmediate(() => {
      if (Settings.get('autosave', 1) != 0) {
        this.makeAutosave();
      }

      setTimeout(() => {
        this.__autosave();
      }, 5 * 60000);

      this.ready = true;
      this.update();
    });
  }

  __bindPageEventListeners(page) {
    page.addEventListener('ready', () => {
      if (this.activePage == page) {
        this.update();
      }
    });

    page.addEventListener('update', () => {
      if (this.activePage == page) {
        this.viewport.selection = page.selection;
        this.update();
      }
    });
  }

  loadPage(filename, name) {
    let page = new Page(filename, name);
    page.id = this.newPageId++;

    this.pages.push(page);

    page.addEventListener('load', () => {
      if (this.activePage == page) {
        this.canvas.width = page.width;
        this.canvas.height = page.height;
        this.viewport.autoScale('start');
      }
      this.triggerEvent('page-loaded', page);
    });

    this.__bindPageEventListeners(page);

    this.triggerEvent('load-page update-pages', page);
    return page;
  }

  loadPages(filenames) {
    let pages = filenames.map(filename => this.loadPage(filename));
    this.selectPage(pages[0]);
    return pages;
  }

  removePage(page) {
    if (Number.isInteger(page)) {
      page = this.pages[page];
    }

    this.pages = this.pages.filter(x => x != page);
    if (this.activePage == page) {
      this.selectPage(0);
    }

    this.triggerEvent('remove-page update-pages', page);
  }

  selectPage(page) {
    if (Number.isInteger(page)) {
      page = this.pages[page];
    }

    if (this.activePage) {
      this.activePage.savedViewportState = this.viewport.saveState();
    }

    this.activePage = page;
    if (this.activePage) {
      this.viewport.restoreState(this.activePage.savedViewportState);
    } else {
      this.viewport.restoreState();
    }

    this.update();

    this.triggerEvent('select-page update-pages', page);
  }

  update() {
    if (this.activePage && this.activePage.selectedLayer && this.activePage.selectedLayer.type == 'text') {
      this.currentFontDefinition.import(this.activePage.selectedLayer.fontDefinition);
      Settings.set('current-font-definition', JSON.stringify(this.currentFontDefinition.export()));
    }

    this.app.forceUpdate();
    //this.ui.update();

    this.render();
  }

  render() {
    if (this.activePage) {
      this.activePage.render(this.canvas);
    } else {
      this.canvas.width = 0;
      this.canvas.height = 0;
    }

    this.viewport.render();
  }

  onClick(x, y) {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }

    if (!this.activePage || !this.activePage.ready || !this.ready)
      return;

    let layer = this.activePage.getLayerAt(x, y);
    if (!layer)
      return;

    if (layer == this.activePage.sourceLayer &&
      (
        !this.activePage.selectedLayer || this.activePage.selectedLayer == layer
      ) &&
      (!this.viewport.selection || (
        x >= this.viewport.selection.left &&
        y >= this.viewport.selection.top &&
        x <= this.viewport.selection.right &&
        y <= this.viewport.selection.bottom
      ))
    ) {
      this.activePage.cleanAt(x, y);
    } else {
      if (layer.type == 'clean' &&
        (!this.viewport.selection || (
          x >= this.viewport.selection.left &&
          y >= this.viewport.selection.top &&
          x <= this.viewport.selection.right &&
          y <= this.viewport.selection.bottom
        ))
      ) {
        let textLayer = new TextLayer(
          this.activePage,
          {
            bounds: null,
            crosshair: {x: x, y: y},
            cleanLayer: layer,
            fontDefinition: this.currentFontDefinition
          }
        );
        this.activePage.addLayer(textLayer);
        textLayer.select();
      } else {
        layer.select();
      }
    }
  }

  onMouseMove(x, y) {
    if (!this.activePage || !this.activePage.ready || !this.ready)
      return;

    let crosshair = this.activePage.crosshairAt(x, y);

    this.viewport.canvas.style.cursor = crosshair ? 'none' : 'crosshair';

    if (crosshair || this.activePage.lastCrosshair) {
      this.render();
    }

    this.activePage.lastCrosshair = crosshair;
  }

  exportBinary() {
    if (this.activePage) {
      this.activePage.savedViewportState = this.viewport.saveState();
    }

    let data = new DataBlock();
    data.put('Lator102');
    data.putString(this.name);
    data.put4(this.activePage ? this.activePage.id : 0);
    data.put4(this.fontDefinitions.length);
    data.put4(this.pages.length);

    data.putDouble(this.viewport.offset.x, this.viewport.offset.y);
    data.putDouble(this.viewport.scale);

    let fdData = this.currentFontDefinition.exportBinary();
    data.put4(fdData.length);
    data.put(fdData);

    this.fontDefinitions.forEach(fd => {
      fdData = fd.exportBinary();
      data.put4(fdData.length);
      data.put(fdData);
    });

    this.pages.forEach(page => {
      let pageData = page.exportBinary();
      data.put4(pageData.length);
      data.put(pageData);
    });

    return data;
  }

  importBinary(data) {
    this.ready = false;
    this.update();

    setImmediate(() => {
      data = new Lator(new KaitaiStream(data));

      this.name = data.name.value;
      this.pages = [];
      data.pages.map(x => x.data).forEach(pageData => {
        let page = new Page();
        page.id = pageData.id;
        page.name = pageData.name.value;
        page.width = pageData.width|0;
        page.height = pageData.height|0;
        page.savedViewportState = {
          selection: (pageData.viewportSelectionExists ? {
            left: pageData.selection.left,
            top: pageData.selection.top,
            right: pageData.selection.right,
            bottom: pageData.selection.bottom
          } : null),
          offset: {
            x: pageData.viewportOffset.x,
            y: pageData.viewportOffset.y
          },
          scale: pageData.viewportScale
        };
        page.selection = page.savedViewportState.selection;

        page.canvas = document.createElement('canvas');
        page.canvas.width = page.width;
        page.canvas.height = page.height;
        page.context = page.canvas.getContext('2d');

        page.overlay = document.createElement('canvas');
        page.overlay.width = page.width;
        page.overlay.height = page.height;
        page.overlayContext = page.overlay.getContext('2d');

        page.layers = [];
        pageData.layers.map(x => x.data).forEach(layerData => {
          let layer;
          let type = layerData.type.value;
          if (type == 'image') {
            layer = new ImageLayer(page);
          } else if (type == 'clean') {
            layer = new CleanLayer(page);
          } else if (type == 'text') {
            layer = new TextLayer(page);
          } else {
            return;
          }

          layer.id = layerData.id;
          layer.name = layerData.name.value;
          layer.x = layerData.x|0;
          layer.y = layerData.y|0;
          layer.width = layerData.width|0;
          layer.height = layerData.height|0;
          layer.opacity = layerData.opacity;
          layer.visible = layerData.visible != 0;
          layer.blendingMode = layerData.blendingMode.value;

          layer.canvas = document.createElement('canvas');
          layer.canvas.width = layer.width;
          layer.canvas.height = layer.height;
          layer.context = layer.canvas.getContext('2d');

          let img = new Image();
          img.onload = () => {
            layer.context.drawImage(img, 0, 0);
            page.update();
          };
          img.src = 'data:image/png;base64,' + base64js.fromByteArray(layerData.imageData);

          if (layer.id == pageData.sourceLayerId) {
            page.sourceLayer = layer;
            page.source.src = img.src;
          }

          if (layer.type == 'clean') {
            let input = new Buffer(layerData.extraData.mask);
            let uncompressed = new Buffer(layerData.extraData.maskLength);
            let uncompressedSize = LZ4.decodeBlock(input, uncompressed);
            layer.mask = uncompressed.slice(0, uncompressedSize);
          } else if (layer.type == 'text') {
            let extra = layerData.extraData;

            layer.baseSize = {
              width: extra.baseWidth,
              height: extra.baseHeight
            };

            layer.boundsMode = extra.boundsMode.value;
            layer.crosshair = {
              x: extra.crosshair.x|0,
              y: extra.crosshair.y|0
            };
            layer.cleanLayerId = extra.cleanLayerId;
            layer.text = extra.text.value;
            layer.fontDefinition = new FontDefinition();
            layer.fontDefinition.importKaitai(extra.fontDefinition.data);

            layer.params = {
              bounds: layer.boundsMode == 'auto' ? 'auto' : {
                left: layer.x,
                top: layer.y,
                right: layer.x + layer.width,
                bottom: layer.y + layer.height
              },
              crosshair: layer.crosshair,
              fontDefinition: layer.fontDefinition
            };

            layer.angle = extra.angle;
          }

          page.layers.push(layer);
        });

        page.layers.forEach(layer => {
          if (layer.type == 'text') {
            layer.cleanLayer = page.layers.find(x => x.id == layer.cleanLayerId);
            layer.update();
          }
        });

        page.layerId = (Math.max.apply(Math, page.layers.map(x => x.id))|0) + 1;
        page.layerIndex = page.layerId;
        page.selectedLayer = page.layers.find(x => x.id == pageData.selectedLayerId);
        page.selection = page.selectedLayer ? page.selectedLayer.selection : null;

        let ids = {};
        page.layers.forEach(layer => {
          if (ids[layer.id]) {
            layer.id = page.layerId++;
          }
          ids[layer.id] = true;
        });

        this.__bindPageEventListeners(page);
        this.pages.push(page);
      });

      this.activePage = this.pages.find(x => x.id == data.activePageId);
      this.newPageId = (Math.max.apply(Math, this.pages.map(x => x.id))|0) + 1;

      let ids = {};
      this.pages.forEach(page => {
        if (ids[page.id]) {
          page.id = this.newPageId++;
        }
        ids[page.id] = true;
      });

      this.currentFontDefinition = new FontDefinition();
      this.currentFontDefinition.importKaitai(data.currentFontDefinition.data);
      this.fontDefinitions = data.fontDefinitions.map(x => x.data).map(fdData => {
        let fd = new FontDefinition();
        fd.importKaitai(fdData);
        return fd;
      });

      if (this.activePage) {
        this.viewport.restoreState(this.activePage.savedViewportState);
      }

      this.viewport.offset.x = data.viewportOffset.x;
      this.viewport.offset.y = data.viewportOffset.y;
      this.viewport.scale = data.viewportScale;
      this.viewport.update();

      this.triggerEvent('update-pages');

      setTimeout(() => {
        this.ready = true;
        this.update();
      }, 100);
    });
  }

  clear() {
    this.pages = [];
    this.activePage = null;
    this.triggerEvent('update-pages');
    this.update();
  }

  updateFontDefinition(name, fd, setAsCurrent) {
    let updateLayerFd = (layerFd, oldFd, fd) => {
      if (layerFd.name != fd.name)
        return false;

      let exp = oldFd.export();
      Object.keys(exp).filter(x => !['fontSize', 'lineHeight'].includes(x)).forEach(key => {
        if (layerFd[key] == exp[key]) {
          layerFd[key] = fd[key];
        }
      });

      return true;
    };

    let existing = this.fontDefinitions.find(x => x.name == name);
    if (!existing) {
      if (fd) {
        fd.name = name;
        this.fontDefinitions.push(fd);

        if (setAsCurrent) {
          this.currentFontDefinition.import(fd.export());

          if (this.activePage && this.activePage.selectedLayer && this.activePage.selectedLayer.type == 'text') {
            this.activePage.selectedLayer.fontDefinition.import(fd.export());
            this.activePage.selectedLayer.update();
          }
        }
      }
    } else {
      if (fd) {
        fd.name = name;

        updateLayerFd(this.currentFontDefinition, existing, fd);
        this.pages.forEach(page => {
          page.layers.forEach(layer => {
            if (layer.type == 'text') {
              if (updateLayerFd(layer.fontDefinition, existing, fd)) {
                layer.update();
              }
            }
          });
        });

        existing.import(fd.export());

        if (setAsCurrent) {
          this.currentFontDefinition.import(fd.export());
        }
      } else {
        if (this.currentFontDefinition.name == name) {
          this.currentFontDefinition.name = '';
        }
        this.pages.forEach(page => {
          page.layers.forEach(layer => {
            if (layer.type == 'text' && layer.fontDefinition.name == name) {
              layer.fontDefinition.name = '';
            }
          });
        });

        this.fontDefinitions = this.fontDefinitions.filter(x => x.name != name);
      }
    }

    Settings.set('font-definitions', JSON.stringify(this.fontDefinitions.map(x => x.export())));
    this.update();
  }
}
